<template>
  <div>
    <PpcHeader26 :contactPhone="ppcPhone" :bLocation="franchiseCityState" />
    <div class="container bg-white mx-auto p-0" v-if="isPremiumPackage">
      <!-- Form -->
      <DefaultQuoteForm26
        :ppcData="ppcData"
        :reviews="reviews"
        :errors="errors"
        :currentPackage="currentPackage"
        :isFormSubmitProcessing="isFormSubmitProcessing"
        @submit="handleFormSubmit"
        ref="formComponent"
        :isPremiumPackage="isPremiumPackage"
        :bLocation="franchiseCityState" />

      <div class="hidden md:block">
        <!--- Why Choose Preminum Package -->
        <PPChoose
          :ppcData="ppcData"
          :urlLocation="urlLocation"
          :currentPackage="currentPackage" />

        <!-- Healthier -->
        <Curves background="fff" foreground="EEF1F4" location="topRight" />
        <div class="container bg-gray-200">
          <PPHealthier
            :imageSrc="urlLocation + ppcData.marketing_block_6_image"
            :currentPackage="currentPackage"
            :heading="ppcData.marketing_block_6_heading"
            :description="ppcData.marketing_block_6_copy"
            primaryButtonText="Get a Free Quote"
            @scroll-to-form="notifyFormComponent" />
        </div>
        <Curves background="fff" foreground="EEF1F4" location="bottomRight" />

        <!--Established -->
        <Curves background="fff" foreground="fff" location="bottomRight" />
        <div class="container bg-white pr-12 pl-0">
          <PPEstablished
            :backgroundImage="`${$config.public.sgCmsImage + ppcData.marketing_block_5_image}`"
            :logoImage="urlLocation + ppcData.marketing_block_4_image"
            :mainHeading="ppcData.marketing_block_4_heading"
            :subHeading="ppcData.marketing_block_4_copy"
            :description="ppcData.marketing_block_5_copy"
            :currentPackage="currentPackage" />
        </div>
        <Curves background="fff" foreground="fff" location="bottomRight" />

        <!--- Stand Out -->
        <PPStandsOut
          :ppcData="ppcData"
          :urlLocation="urlLocation"
          :currentPackage="currentPackage" />
        <Curves background="fff" foreground="fff" location="bottomRight" />
      </div>
    </div>

    <div class="container bg-white mx-auto p-0" v-else>
      <DefaultQuoteForm26
        :ppcData="ppcData"
        :reviews="reviews"
        :errors="errors"
        :isFormSubmitProcessing="isFormSubmitProcessing"
        @submit="handleFormSubmit"
        :isPremiumPackage="isPremiumPackage"
        :bLocation="franchiseCityState" />

      <div class="hidden md:block">
        <Curves
          background="EEF1F4"
          foreground="fff"
          location="bottomRight"
          v-if="featuredServices && featuredServices.length > 0" />
        <Curves
          background="fff"
          foreground="EEF1F4"
          location="topLeft"
          v-if="featuredServices && featuredServices.length > 0" />

        <div
          class="mx-auto bg-gray-200 px-8 py-1"
          v-if="featuredServices && featuredServices.length > 0">
          <div class="w-full">
            <h2
              class="text-center mb-8"
              v-if="featuredServices && featuredServices.length > 0">
              Recommended Services
            </h2>

            <ServicesCardList
              v-if="featuredServices && featuredServices.length > 0"
              :services="featuredServices"
              borderOverride="green"
              :hidePurchased="true"
              size="small" />
          </div>
        </div>

        <Curves
          background="fff"
          foreground="EEF1F4"
          location="bottomLeft"
          v-if="featuredServices && featuredServices.length > 0" />
        <Curves
          background="EEF1F4"
          foreground="fff"
          location="topRight"
          v-if="featuredServices && featuredServices.length > 0" />

        <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:pb-10" v-if="franchiseLocation">
          <div class="ps-0 md:pl-8 fcard">
            <FranchiseFranchiseeCard :name="signature" :location="franchiseLocation" :franchiseeImageSrc="franchiseeImg"
              :signatureImageSrc="franchiseeImg" :phone="ppcPhone" />
            <p class="green font-bold py-4 px-3 md:px-0">
              We'd be happy to take care of your yard.<br />
            </p>
            <p class="mt-4 px-3 md:px-0" v-if="userAddress">
              Your address: <br />
              <strong>{{ userAddress }}</strong>
            </p>
          </div>
          <div class="md:pr-8 px-3">
            <div v-if="franchiseeBio" v-html="franchiseeBio"></div>
          </div>
        </div>

        <Curves background="EEF1F4" foreground="fff" location="bottomRight" />
        <Curves background="fff" foreground="EEF1F4" location="topLeft" /> -->

        </div>

        <!-- About Us : Higher Standards section -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:my-16 my-8 about-section">
          <div
            class="about-content text-white place-content-center flex flex-col gap-2">
            <div class="flex flex-nowrap gap-1 items-center">
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 8C0 3.58172 3.58172 0 8 0H20V8C20 12.4183 16.4183 16 12 16H0V8Z"
                  fill="white" />
              </svg>
              <div>ABOUT US</div>
            </div>
            <h2 class="text-white">Our Higher Standards</h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
              <div class="grid gap-4 grid-cols-2 higher-standards-logo-section">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_13487_2879)">
                    <mask
                      id="mask0_13487_2879"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="36"
                      height="36">
                      <path d="M36 0H0V36H36V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_13487_2879)">
                      <path
                        d="M26.5775 27.1358C25.6968 27.1358 24.8689 26.7931 24.2467 26.1708L21.2674 23.1915C20.8561 22.7802 20.8561 22.1105 21.2674 21.6992C21.6787 21.2879 22.3484 21.2879 22.7597 21.6992L25.739 24.6785C25.9658 24.9053 26.2611 25.0266 26.5827 25.0266C26.9044 25.0266 27.1997 24.9053 27.4264 24.6785C27.8905 24.2145 27.8905 23.4604 27.4264 22.9964L27.1786 22.7485C27.1786 22.7485 27.1786 22.7485 27.1733 22.7433L20.1231 15.693L19.1897 16.6264C18.4726 17.3435 17.5234 17.7338 16.511 17.7338C15.4985 17.7338 14.5493 17.3383 13.8322 16.6264C13.1098 15.904 12.7143 14.939 12.7248 13.916C12.7354 12.893 13.1414 11.9385 13.8796 11.2266L20.0914 5.20468C23.7299 1.57673 29.6412 1.57673 33.2744 5.20995C35.0356 6.97119 36.0059 9.31248 36.0059 11.8014C36.0059 14.2904 35.0356 16.6317 33.2744 18.3929C33.2691 18.3982 33.2586 18.4087 33.2533 18.414L29.3828 22.0736C30.1896 23.3497 30.0367 25.0582 28.924 26.1656C27.8114 27.2729 27.4739 27.1306 26.5933 27.1306L26.5775 27.1358ZM20.1125 13.1461C20.392 13.1461 20.661 13.2568 20.8561 13.4572L27.9327 20.5338L31.7768 16.9006C33.132 15.5401 33.8808 13.7314 33.8808 11.8067C33.8808 9.88199 33.132 8.06801 31.7663 6.70226C28.9557 3.89166 24.3733 3.88638 21.5627 6.70226C21.5627 6.70226 21.5574 6.70753 21.5521 6.71281L15.335 12.7453C15.0081 13.0617 14.8288 13.4836 14.8235 13.9371C14.8235 14.3906 14.9923 14.8177 15.3139 15.1341C15.6356 15.4505 16.0522 15.6245 16.5004 15.6245C16.9486 15.6245 17.3705 15.4505 17.6869 15.1341L19.369 13.4519C19.5694 13.2515 19.8331 13.1408 20.1125 13.1408V13.1461Z"
                        fill="white" />
                      <path
                        d="M23.1708 30.479C22.2427 30.479 21.3726 30.1205 20.7187 29.4666L18.7518 27.4997C18.3405 27.0884 18.3405 26.4187 18.7518 26.0074C19.1631 25.5961 19.8328 25.5961 20.2441 26.0074L22.211 27.9743C22.4694 28.2327 22.8069 28.3698 23.1708 28.3698C23.5346 28.3698 23.8721 28.2274 24.1305 27.9743C24.6578 27.447 24.6578 26.5874 24.1305 26.0548L22.153 24.0774C21.7417 23.6661 21.7417 22.9964 22.153 22.5851C22.5643 22.1738 23.234 22.1738 23.6454 22.5851L25.6228 24.5625C26.9727 25.9125 26.9727 28.1114 25.6228 29.4613C24.9689 30.1152 24.0988 30.4738 23.1708 30.4738V30.479Z"
                        fill="white" />
                      <path
                        d="M4.5404 19.996C4.27147 19.996 4.00254 19.8905 3.79689 19.6849L2.86881 18.7568C1.02319 16.9217 0.0107422 14.4697 0.0107422 11.8648C0.0107422 9.25981 1.02319 6.80778 2.86881 4.96744C4.70915 3.1271 7.16117 2.10938 9.76612 2.10938C12.3711 2.10938 14.8231 3.12183 16.6634 4.96744L19.184 7.48802C19.5953 7.89933 19.5953 8.56902 19.184 8.98033C18.7727 9.39164 18.103 9.39164 17.6917 8.98033L15.1711 6.45975C13.7263 5.0149 11.8068 4.21865 9.76612 4.21865C7.7254 4.21865 5.80597 5.0149 4.36112 6.45975C2.91626 7.9046 2.12001 9.82404 2.12001 11.8648C2.12001 13.9055 2.91626 15.8249 4.36112 17.2698L5.2892 18.1978C5.7005 18.6092 5.7005 19.2788 5.2892 19.6902C5.08354 19.8958 4.81461 20.0013 4.54568 20.0013L4.5404 19.996Z"
                        fill="white" />
                      <path
                        d="M12.2072 32.3194C11.3108 32.3194 10.4091 31.9767 9.72885 31.2912L9.69722 31.2595C9.03279 30.5951 8.66895 29.7145 8.66895 28.7811C8.66895 27.8478 9.03279 26.9619 9.69722 26.3027L12.8611 23.1388C14.2269 21.7731 16.4522 21.7731 17.8232 23.1388L17.8548 23.1705C19.2206 24.5362 19.2206 26.7615 17.8548 28.1325L14.6909 31.2964C14.0054 31.9819 13.109 32.3247 12.2125 32.3247L12.2072 32.3194ZM15.3395 24.2198C14.9809 24.2198 14.6224 24.3569 14.3482 24.6311L11.1843 27.795C10.9206 28.0587 10.7729 28.412 10.7729 28.7864C10.7729 29.1608 10.9206 29.5088 11.1843 29.7778L11.2159 29.8094C11.759 30.3525 12.6502 30.3525 13.1933 29.8094L16.3572 26.6455C16.9004 26.1023 16.9004 25.2112 16.3572 24.668L16.3256 24.6364C16.0514 24.3622 15.6928 24.2251 15.3342 24.2251L15.3395 24.2198Z"
                        fill="white" />
                      <path
                        d="M8.70627 28.818C7.80983 28.818 6.90812 28.4752 6.22788 27.7897L6.19624 27.7581C5.53182 27.0936 5.16797 26.213 5.16797 25.2797C5.16797 24.3463 5.53182 23.4604 6.19624 22.8013L9.36015 19.6374C10.7259 18.2716 12.9512 18.2716 14.3222 19.6374L14.3538 19.669C15.7196 21.0347 15.7196 23.26 14.3538 24.6311L11.1899 27.795C10.5044 28.4805 9.60799 28.8232 8.71155 28.8232L8.70627 28.818ZM11.8385 20.7184C11.48 20.7184 11.1214 20.8555 10.8472 21.1297L7.68328 24.2936C7.41962 24.5572 7.27197 24.9105 7.27197 25.2849C7.27197 25.6593 7.41962 26.0074 7.68328 26.2763L7.71491 26.3079C8.25805 26.8511 9.14922 26.8511 9.69236 26.3079L12.8563 23.144C13.3994 22.6009 13.3994 21.7097 12.8563 21.1666L12.8246 21.1349C12.5504 20.8607 12.1918 20.7236 11.8333 20.7236L11.8385 20.7184Z"
                        fill="white" />
                      <path
                        d="M5.2053 25.3219C4.30886 25.3219 3.40714 24.9791 2.7269 24.2936L2.69526 24.262C2.03084 23.5975 1.66699 22.7169 1.66699 21.7836C1.66699 20.8502 2.03084 19.9643 2.69526 19.3052L5.85917 16.1413C7.22492 14.7755 9.45021 14.7755 10.8212 16.1413L10.8529 16.1729C12.2186 17.5387 12.2186 19.7639 10.8529 21.135L7.68896 24.2989C7.00345 24.9844 6.10701 25.3271 5.21057 25.3271L5.2053 25.3219ZM8.33757 17.217C7.96317 17.217 7.61514 17.3646 7.34621 17.6283L4.1823 20.7922C3.91864 21.0559 3.77099 21.4092 3.77099 21.7836C3.77099 22.158 3.91864 22.506 4.1823 22.7749L4.21394 22.8066C4.75708 23.3497 5.64824 23.3497 6.19138 22.8066L9.35529 19.6426C9.89843 19.0995 9.89843 18.2083 9.35529 17.6652L9.32365 17.6336C9.05999 17.3699 8.70669 17.2223 8.33229 17.2223L8.33757 17.217Z"
                        fill="white" />
                      <path
                        d="M19.759 33.8856C18.8309 33.8856 17.9609 33.5271 17.307 32.8732L14.4647 30.0309C14.0534 29.6196 14.0534 28.9499 14.4647 28.5386C14.876 28.1273 15.5457 28.1273 15.957 28.5386L18.7993 31.3809C19.0577 31.6393 19.3952 31.7764 19.759 31.7764C20.1229 31.7764 20.4603 31.634 20.7187 31.3809C20.9771 31.1225 21.1142 30.785 21.1142 30.4212C21.1142 30.0573 20.9718 29.7198 20.7187 29.4614L17.8923 26.635C17.481 26.2237 17.481 25.554 17.8923 25.1427C18.3036 24.7314 18.9733 24.7314 19.3846 25.1427L22.211 27.9691C22.8649 28.623 23.2235 29.4931 23.2235 30.4212C23.2235 31.3492 22.8649 32.2193 22.211 32.8732C21.5572 33.5271 20.6871 33.8856 19.759 33.8856Z"
                        fill="white" />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_13487_2879">
                      <rect width="36" height="36" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <div>
                  <h3 class="text-white">Professionalism</h3>
                  <p class="text-white">
                    Reliable, well-trained professionals with annual
                    certifications.
                  </p>
                </div>
              </div>
              <div class="grid gap-4 grid-cols-2 higher-standards-logo-section">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_13487_2957)">
                    <path
                      d="M21.2092 11.9531C21.4248 11.9531 21.6393 11.8861 21.8198 11.7548C22.1257 11.5326 22.2867 11.1613 22.2397 10.7858L21.8604 7.75222L23.9506 5.5209C24.2093 5.2446 24.2972 4.84991 24.1802 4.48984C24.0632 4.13003 23.7599 3.86252 23.3883 3.79111L20.386 3.21432L18.9098 0.536957C18.7271 0.205719 18.3786 0 18.0004 0C17.6219 0 17.2736 0.205719 17.091 0.536957L15.6147 3.21432L12.6121 3.79111C12.2408 3.86224 11.9373 4.13003 11.8203 4.48984C11.7036 4.84991 11.7914 5.2446 12.0502 5.5209L14.1403 7.75222L13.761 10.7858C13.7138 11.1613 13.8747 11.5326 14.181 11.7548C14.4869 11.9773 14.8896 12.0157 15.2324 11.8548L18.0004 10.5568L20.7684 11.8548C20.909 11.9207 21.0595 11.9531 21.2092 11.9531ZM19.7392 7.52673L19.9452 9.17495L18.4415 8.46963C18.3017 8.40399 18.1512 8.3713 18.0004 8.3713C17.8499 8.3713 17.6991 8.40399 17.5595 8.46963L16.0555 9.17495L16.2615 7.52673C16.3 7.22049 16.2 6.91314 15.989 6.68792L14.8536 5.47558L16.4848 5.1622C16.7878 5.10397 17.0492 4.91418 17.1984 4.64392L18.0004 3.18905L18.8024 4.64364C18.9515 4.91391 19.213 5.10397 19.5159 5.1622L21.1474 5.47531L20.0117 6.68792C19.8008 6.91314 19.7008 7.22049 19.7392 7.52673Z"
                      fill="white" />
                    <path
                      d="M35.9489 15.0367C35.8319 14.6769 35.5286 14.4091 35.157 14.3377L32.1545 13.761L30.6782 11.0836C30.4955 10.7523 30.1473 10.5466 29.7688 10.5466C29.3906 10.5466 29.042 10.7523 28.8594 11.0836L27.3831 13.761L24.3808 14.3377C24.0092 14.4091 23.706 14.6769 23.589 15.0367C23.472 15.3965 23.5601 15.7912 23.8186 16.0675L25.9087 18.2989L25.5294 21.3327C25.4825 21.7082 25.6434 22.0792 25.9494 22.3014C26.2554 22.5239 26.658 22.5624 27.0008 22.4017L29.7688 21.1034L32.5371 22.4017C32.6774 22.4676 32.8279 22.5 32.9776 22.5C33.1935 22.5 33.4077 22.4327 33.5882 22.3017C33.8941 22.0792 34.0551 21.7082 34.0081 21.3327L33.6288 18.2991L35.719 16.0675C35.9777 15.7915 36.0659 15.3965 35.9489 15.0367ZM31.7801 17.2346C31.5692 17.4598 31.4695 17.7671 31.5076 18.0734L31.7139 19.7216L30.2099 19.0163C30.0701 18.9509 29.9196 18.9179 29.7691 18.9179C29.6183 18.9179 29.4678 18.9509 29.328 19.0163L27.8239 19.7216L28.0302 18.0734C28.0684 17.7671 27.9687 17.4598 27.7575 17.2346L26.622 16.0222L28.2532 15.7088C28.5564 15.6506 28.8179 15.4608 28.9668 15.1905L29.7688 13.7357L30.5711 15.1905C30.7199 15.4608 30.9814 15.6506 31.2846 15.7088L32.9158 16.0222L31.7801 17.2346Z"
                      fill="white" />
                    <path
                      d="M16.1188 27.8377L13.1165 27.2612L11.6402 24.5839C11.4576 24.2526 11.109 24.0466 10.7308 24.0466C10.3524 24.0466 10.0041 24.2526 9.82144 24.5839L8.34516 27.2612L5.3426 27.8377C4.97098 27.9091 4.66776 28.1769 4.55076 28.5367C4.43403 28.8965 4.52192 29.2915 4.78064 29.5675L6.87052 31.7989L6.49122 34.8327C6.44425 35.2082 6.6052 35.5792 6.91144 35.8017C7.21741 36.0239 7.62006 36.0626 7.96256 35.9017L10.7308 34.6034L13.4988 35.9017C13.6392 35.9676 13.7897 36 13.9397 36C14.1553 36 14.3695 35.9327 14.55 35.8017C14.8562 35.5792 15.0172 35.2082 14.9702 34.8327L14.5906 31.7989L16.6808 29.5675C16.9395 29.2915 17.0274 28.8965 16.9106 28.5367C16.7939 28.1769 16.4904 27.9091 16.1188 27.8377ZM12.7422 30.7346C12.5312 30.9598 12.4312 31.2671 12.4694 31.5734L12.6757 33.2216L11.1717 32.5163C11.0321 32.4509 10.8814 32.4179 10.7308 32.4179C10.58 32.4179 10.4295 32.4509 10.2897 32.5163L8.78598 33.2216L8.99198 31.5734C9.03043 31.2671 8.93045 30.9598 8.71952 30.7346L7.58381 29.5222L9.215 29.2088C9.51822 29.1506 9.7797 28.9605 9.92856 28.6905L10.7308 27.2357L11.5328 28.6905C11.6817 28.9605 11.9432 29.1506 12.2464 29.2088L13.8776 29.5222L12.7422 30.7346Z"
                      fill="white" />
                    <path
                      d="M30.657 27.8377L27.6545 27.2612L26.1782 24.5839C25.9955 24.2526 25.6473 24.0466 25.2688 24.0466C24.8906 24.0466 24.5423 24.2526 24.3594 24.5839L22.8831 27.2612L19.8808 27.8377C19.5092 27.9091 19.206 28.1769 19.089 28.5367C18.972 28.8965 19.0601 29.2915 19.3186 29.5675L21.4087 31.7989L21.0294 34.8327C20.9825 35.2082 21.1434 35.5792 21.4494 35.8017C21.7553 36.0239 22.158 36.0626 22.5008 35.9017L25.2688 34.6034L28.0371 35.9017C28.1774 35.9676 28.3279 36 28.4776 36C28.6935 36 28.9077 35.9327 29.0882 35.8017C29.3941 35.5792 29.5551 35.2082 29.5081 34.8327L29.1288 31.7989L31.219 29.5675C31.4777 29.2915 31.5656 28.8965 31.4486 28.5367C31.3319 28.1769 31.0286 27.9091 30.657 27.8377ZM27.2804 30.7346C27.0692 30.9598 26.9695 31.2671 27.0076 31.5734L27.2139 33.2216L25.7099 32.5163C25.5701 32.4509 25.4196 32.4179 25.2691 32.4179C25.1183 32.4179 24.9678 32.4509 24.8279 32.5163L23.3239 33.2216L23.5302 31.5734C23.5686 31.2671 23.4687 30.9598 23.2577 30.7346L22.122 29.5222L23.7532 29.2088C24.0564 29.1506 24.3179 28.9605 24.4668 28.6905L25.2688 27.2357L26.0711 28.6905C26.2199 28.9605 26.4814 29.1506 26.7846 29.2088L28.4158 29.5222L27.2804 30.7346Z"
                      fill="white" />
                    <path
                      d="M8.99885 22.4017C9.1392 22.4676 9.28971 22.5 9.43967 22.5C9.65528 22.5 9.86951 22.4327 10.0502 22.3017C10.3562 22.0792 10.5172 21.7082 10.4702 21.3327L10.0909 18.2991L12.1808 16.0675C12.4395 15.7915 12.5277 15.3965 12.4107 15.0367C12.2936 14.6769 11.9904 14.4091 11.6188 14.3377L8.61625 13.7612L7.13996 11.0839C6.95731 10.7526 6.60905 10.5466 6.23057 10.5466C5.85237 10.5466 5.50382 10.7526 5.32118 11.0839L3.84516 13.761L0.842602 14.3377C0.47099 14.4091 0.167767 14.6769 0.050763 15.0367C-0.0659667 15.3965 0.0219239 15.7912 0.280377 16.0675L2.37052 18.2989L1.99122 21.3327C1.94426 21.7082 2.10521 22.0792 2.41117 22.3014C2.71714 22.5239 3.12007 22.5624 3.46257 22.4017L6.23084 21.1034L8.99885 22.4017ZM4.28599 19.7216L4.49198 18.0734C4.53044 17.7671 4.43046 17.4598 4.21952 17.2346L3.08381 16.0222L4.71501 15.7088C5.01823 15.6506 5.2797 15.4608 5.42857 15.1905L6.23084 13.7357L7.03285 15.1905C7.18171 15.4608 7.44318 15.6506 7.74641 15.7088L9.3776 16.0222L8.24216 17.2346C8.03123 17.4598 7.93125 17.7671 7.96943 18.0734L8.1757 19.7216L6.67167 19.0163C6.53214 18.9509 6.38136 18.9179 6.23084 18.9179C6.08006 18.9179 5.92954 18.9509 5.78974 19.0163L4.28599 19.7216Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_13487_2957">
                      <rect width="36" height="36" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <div>
                  <h3 class="text-white">Quality</h3>
                  <p class="text-white">
                    Beaufiful yards and pest-free homes with eco-responsible
                    solutions.
                  </p>
                </div>
              </div>
              <div class="grid gap-4 grid-cols-2 higher-standards-logo-section">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <mask
                    id="mask0_13487_2923"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36">
                    <path d="M36 0H0V36H36V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_13487_2923)">
                    <path
                      d="M29.2981 34.8662C29.1873 34.8662 29.0713 34.8504 28.9658 34.8135L25.9127 33.7958L22.8595 34.8135C22.5378 34.919 22.1845 34.8662 21.9103 34.6711C21.6361 34.476 21.4727 34.1544 21.4727 33.8169V26.6401C21.4727 26.06 21.9472 25.5854 22.5273 25.5854C23.1073 25.5854 23.5819 26.06 23.5819 26.6401V32.3562L25.5805 31.6918C25.7967 31.618 26.0287 31.618 26.2449 31.6918L28.2434 32.3562V26.6401C28.2434 26.06 28.718 25.5854 29.2981 25.5854C29.8781 25.5854 30.3527 26.06 30.3527 26.6401V33.8169C30.3527 34.1544 30.1892 34.476 29.915 34.6711C29.7357 34.803 29.5195 34.8715 29.2981 34.8715V34.8662Z"
                      fill="white" />
                    <path
                      d="M25.9068 29.2185C22.8325 29.2185 20.333 26.7191 20.333 23.6448C20.333 20.5705 22.8325 18.071 25.9068 18.071C28.981 18.071 31.4805 20.5705 31.4805 23.6448C31.4805 26.7191 28.981 29.2185 25.9068 29.2185ZM25.9068 20.1856C23.9979 20.1856 22.4423 21.7412 22.4423 23.6501C22.4423 25.559 23.9979 27.1145 25.9068 27.1145C27.8156 27.1145 29.3712 25.559 29.3712 23.6501C29.3712 21.7412 27.8156 20.1856 25.9068 20.1856Z"
                      fill="white" />
                    <path
                      d="M28.1644 10.0189H7.831C7.25095 10.0189 6.77637 9.54435 6.77637 8.9643C6.77637 8.38425 7.25095 7.90967 7.831 7.90967H28.1644C28.7444 7.90967 29.219 8.38425 29.219 8.9643C29.219 9.54435 28.7444 10.0189 28.1644 10.0189Z"
                      fill="white" />
                    <path
                      d="M25.907 15.6666H10.0927C9.51267 15.6666 9.03809 15.1921 9.03809 14.612C9.03809 14.032 9.51267 13.5574 10.0927 13.5574H25.907C26.487 13.5574 26.9616 14.032 26.9616 14.612C26.9616 15.1921 26.487 15.6666 25.907 15.6666Z"
                      fill="white" />
                    <path
                      d="M25.907 20.1857H10.0927C9.51267 20.1857 9.03809 19.7111 9.03809 19.1311C9.03809 18.551 9.51267 18.0764 10.0927 18.0764H25.907C26.487 18.0764 26.9616 18.551 26.9616 19.1311C26.9616 19.7111 26.487 20.1857 25.907 20.1857Z"
                      fill="white" />
                    <path
                      d="M21.3879 24.6996H10.0927C9.51267 24.6996 9.03809 24.225 9.03809 23.645C9.03809 23.0649 9.51267 22.5903 10.0927 22.5903H21.3879C21.9679 22.5903 22.4425 23.0649 22.4425 23.645C22.4425 24.225 21.9679 24.6996 21.3879 24.6996Z"
                      fill="white" />
                    <path
                      d="M34.9454 31.4808H29.2978C28.7177 31.4808 28.2432 31.0063 28.2432 30.4262C28.2432 29.8462 28.7177 29.3716 29.2978 29.3716H33.8907V3.23769H2.10927V29.3716H22.5165C23.0965 29.3716 23.5711 29.8462 23.5711 30.4262C23.5711 31.0063 23.0965 31.4808 22.5165 31.4808H1.05464C0.474586 31.4808 0 31.0063 0 30.4262V2.18305C0 1.603 0.474586 1.12842 1.05464 1.12842H34.9454C35.5254 1.12842 36 1.603 36 2.18305V30.4262C36 31.0063 35.5254 31.4808 34.9454 31.4808Z"
                      fill="white" />
                  </g>
                </svg>

                <div>
                  <h3 class="text-white">Service</h3>
                  <p class="text-white">Prompt, courteous service with profpssional results.</p>
                </div>
              </div>
              <div class="grid gap-4 grid-cols-2 higher-standards-logo-section">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_13487_2968)">
                    <path
                      d="M19.6902 16.898H16.3106C15.0548 16.898 14.033 15.8763 14.033 14.6204C14.033 13.3646 15.0548 12.3429 16.3106 12.3429H23.0698C23.6784 12.3429 24.1718 11.8494 24.1718 11.2409C24.1718 10.6323 23.6784 10.1388 23.0698 10.1388H19.1025V7.86128C19.1025 7.25266 18.6091 6.75928 18.0005 6.75928C17.3919 6.75928 16.8985 7.25273 16.8985 7.86128V10.1388H16.3107C13.8395 10.1388 11.8291 12.1493 11.8291 14.6205C11.8291 17.0917 13.8395 19.1021 16.3107 19.1021H19.6903C20.9461 19.1021 21.9679 20.1239 21.9679 21.3797C21.9679 22.6356 20.9462 23.6573 19.6903 23.6573H12.9311C12.3225 23.6573 11.8291 24.1507 11.8291 24.7593C11.8291 25.3678 12.3226 25.8613 12.9311 25.8613H16.8984V28.1388C16.8984 28.7475 17.3919 29.2409 18.0004 29.2409C18.6091 29.2409 19.1024 28.7474 19.1024 28.1388V25.8613H19.6902C22.1614 25.8613 24.1718 23.8508 24.1718 21.3796C24.1718 18.9084 22.1614 16.898 19.6902 16.898Z"
                      fill="white" />
                    <path
                      d="M30.7279 5.2721C27.3282 1.87228 22.808 0 18 0C13.192 0 8.67178 1.87228 5.2721 5.2721C1.87235 8.67185 0 13.192 0 18C0 22.808 1.87228 27.3282 5.2721 30.7279C8.67185 34.1277 13.192 36 18 36C22.808 36 27.3282 34.1277 30.7279 30.7279C34.1277 27.3282 36 22.808 36 18C36 13.192 34.1277 8.67178 30.7279 5.2721ZM18 33.7959C9.29011 33.7959 2.20409 26.7099 2.20409 18C2.20409 9.29011 9.29011 2.20409 18 2.20409C26.7099 2.20409 33.7959 9.29011 33.7959 18C33.7959 26.7099 26.7099 33.7959 18 33.7959Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_13487_2968">
                      <rect width="36" height="36" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <div>
                  <h3 class="text-white">Value</h3>
                  <p class="text-white">Maximum results at an affordable value.</p>
                </div>
              </div>
            </div>
            <!-- /inner grid -->
          </div>
          <!-- /about-content -->
          <img
            src="~/assets/images/home-exterior.jpg"
            alt="Spring Green Exterior Home"
            class="w-full h-full object-cover" />
        </div>
      

        <!-- <DefaultStandsOut :ppcData="ppcData" :urlLocation="urlLocation" />

        <Curves background="fff" foreground="EEF1F4" location="bottomLeft" />
        <Curves background="EEF1F4" foreground="fff" location="topRight" /> -->

        <!-- Reviews Carousel -->
        <PPCReviewsCarousel :location="franchiseCityState" :branchCode="branchCode" />

        <div class="estimate-section text-center py-12 px-4">
          <h2 class="text-white">{{ franchiseLocation }}'s Trusted Lawn Care Experts<br/>Get Your FREE Estimate Today!</h2>
          <a class="button-white-alt-white rounded-full !uppercase py-3 px-6 text-sm mt-4 inline-block" href="#">Get a Free Estimate</a>
        </div>

    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, type Ref } from "vue";
import { useRoute, useNuxtApp } from "#app";
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import DefaultStandsOut from "./DefaultStandsOut.vue";
import DefaultQuoteForm26 from "./DefaultQuoteForm26.vue";
import PPCReviewsCarousel from "../PPCReviewsCarousel.vue";
import PPHealthier from "./PPHealthier.vue";
import PPEstablished from "./PPEstablished.vue";
import PPStandsOut from "./PPStandsOut.vue";
import PPChoose from "./PPChoose.vue";
import PpcHeader26 from "~/components/PpcHeader26.vue";
import type State from "~/domains/store/State";
import type ServiceState from "~/domains/store/services/ServiceState";
import type { PpcContactForm } from "~/domains/ppc/PpcContactForm";

const props = defineProps({
  ppcData: { type: Object, required: true },
  reviews: Array,
  errors: { type: Array<string>, default: () => [] },
  isFormSubmitProcessing: Boolean,
});

const emit = defineEmits(["submit"]);

const nuxtApp = useNuxtApp();
const { $sg, $services, $config } = nuxtApp;
const store: Store<State> = useStore();
const route = useRoute();

const urlLocation = ref($config.public.sgCmsImage);
const youtubeLink = ref("");
const franchiseInfo = ref<any[] | null>(null);
const featuredServices = ref<ServiceState[]>();
const signature = ref("");
const franchiseCityState = ref("");
const franchiseLocation = ref("");
const franchiseeImg = ref("");
const franchiseeBio = ref("");
const ppcPhone = ref("");
const userAddress = ref("");

const formComponent: Ref<HTMLElement | null> = ref(null);

const branchInfo = computed(() => store.state.persistedState?.branchInfo);

const branchCode = computed(() => {
  const utmContent = route.query.utm_content;
  return (Array.isArray(utmContent) ? utmContent[0] : utmContent) || "";
});

const isPremiumPackage = computed(() => {
  return !!route.query.utm_content && props.ppcData?.package_id;
});

const currentPackage = computed(() => {
  return props.ppcData?.package_id;
});

onMounted(async () => {
  const persistedState = store.state.persistedState;
  userAddress.value = persistedState.userAddress;

  if (props.ppcData?.ppc_youtube_video_shortcode) {
    youtubeLink.value = `https://www.youtube.com/embed/${props.ppcData?.ppc_youtube_video_shortcode}`;
  }

  const routeQuery = route.query.utm_content;
  if (routeQuery) {
    const franchiseInfoData = await $sg.getOctoberData(
      "franchise/" + routeQuery,
    );
    const franchiseData =
      franchiseInfoData?.find((franchise) => Number(franchise.parent_id) === 0) ??
      franchiseInfoData?.[0];
    franchiseInfo.value = franchiseInfoData;
    const allServiceIds = JSON.parse(
      JSON.stringify(franchiseData?.services_to_display),
    );

    const franchiseServices = $services.getServicesByIds(
      allServiceIds,
      false,
      false,
    );
    if (store.state.persistedState.scope?.id) {
      $services.sortServices(franchiseServices);
      featuredServices.value = franchiseServices?.splice(0, 3);
    } else {
      featuredServices.value = franchiseServices.filter((service) =>
        [2, 3].includes(service.ServiceDefId),
      );
    }

    franchiseLocation.value = franchiseData?.name;
    franchiseCityState.value = franchiseData?.city_state_override;
    franchiseeImg.value =
      "" +
      $config.public.sgCmsImage +
      franchiseData?.franchise_owner_image;
    franchiseeBio.value = franchiseData?.local_information;
  }

  if (branchInfo.value) {
    const branchPhoneField = branchInfo.value.BranchInfo?.InfoData?.find(
      (data) => data.FieldName === "MarchEX Digital Phone",
    );
    ppcPhone.value = branchPhoneField?.FieldValue ?? "";

    const signatureData = branchInfo.value.BranchInfo?.InfoData?.find(
      (data) => data.FieldName === "Franchise Owner Name",
    );
    signature.value = signatureData?.FieldValue ?? "";

    if (!franchiseCityState.value) {
      franchiseCityState.value = store.state.persistedState.branchLocation;
    }
  }
});

const handleFormSubmit = (formData: PpcContactForm) => {
  emit("submit", formData);
};

const notifyFormComponent = () => {
  if (formComponent && formComponent.scrollToForm) {
    formComponent?.scrollToForm();
  }
};
</script>

<style scoped>
.landing-image-width img {
  width: 100%;
}

.landing-background-image {
  background-position: left -71px; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: 1440px 641px; /* Resize the background image to cover the entire container */
  height: 500px;
  border-bottom-left-radius: 70px;
}

.transleaf {
  max-height: 291px;
  max-width: 506px;
  background: linear-gradient(
    180deg,
    rgba(91, 179, 94, 0.309412) 0%,
    #5bb35e 100%
  );
  border-bottom-right-radius: 99px;
  border-top-left-radius: 99px;
  margin: 4em;
}

.transleaf h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
}

.quote {
  background: #f7f7f7;
  border-radius: 36px;
  margin: 4em;
  padding: 1em 2em;
}

.quote h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #517185;
  margin-top: 1rem;
}

.quote p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #517185;
}

.text h2 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  color: #517185;
  font-display: swap;
}

.text h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #517185;
}

.about-section {
  background-color: #4e6b7e;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
}

.about-section img {
  border-top-left-radius: 50px;
}

.about-section .about-content {
  color: #fff;
  padding: 50px 20px;
  order: 2;
  border-bottom-right-radius: 50px;
}

.about-section .about-content h2 {
  font-size: 2.25em;
  line-height: 1;
}

.about-section .higher-standards-logo-section {
  grid-template-columns: 36px 1fr;
}

.estimate-section {
  background: #3b7d2c;
}

.bg-gray-200 {
  background-color: #eef1f4;
}

h4 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #00810e;
  font-display: swap;
}

button {
  background: #00810e;
  border-radius: 100px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  font-display: swap;
}

.reviews-inner {
  background: #fff;
  border-bottom-left-radius: 70px;
  padding: 0 0 40px;
}

@media (max-width: 1120px) {
  .transleaf {
    min-height: 220px;
    margin: 2em;
  }

  .quote {
    margin: 0.5em 1em;
  }
}

@media (max-width: 767px) {
  .transleaf h2 {
    font-size: 30px;
    line-height: 1.2;
    margin-top: 30px;
  }
}

@media (min-width: 768px) {
  .about-section {
    border-bottom-right-radius: 200px;
    border-top-left-radius: 200px;
  }

  .about-section img {
    border-top-left-radius: 0px;
    border-bottom-right-radius: 200px;
  }

  .about-section .about-content {
    color: #fff;
    padding: 100px 50px 100px 100px;
    order: 0;
  }
}

.validation-error {
  color: #ce4200;
}

.checkbox {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
}

.checkbox__control {
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid #00810e;
  background: #fff;
  color: white;
  margin-top: -3px;
}

.checkbox__control svg {
  transition: transform 0.1s ease-in 25ms;
  transform: scale(0);
  transform-origin: bottom left;
}

.checkbox__input {
  display: grid;
  grid-template-areas: "checkbox";
}

.checkbox__input input {
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox__input input:checked + .checkbox__control svg {
  transform: scale(1);
}

.checkbox__input input:checked + .checkbox__control {
  background: #00810e;
}
</style>
